import { Component, Input } from "@angular/core";
import { PopoverController } from "@ionic/angular";

export interface PopoverButton {
  text: string;
  handler: () => void;
  danger?: boolean;
}

@Component({
  selector: "app-popover",
  templateUrl: "./popover.component.html",
  styleUrls: ["./popover.component.scss"],
})
export class PopoverComponent {
  @Input() public buttons: PopoverButton[];

  constructor(public popoverController: PopoverController) {}
}
